import React, { useState, useEffect, useRef } from 'react';
import { Inertia } from '@inertiajs/inertia';
import { usePage } from '@inertiajs/inertia-react';
import { usePrevious } from 'react-use';
import SelectInput from '@/Shared/SelectInput';
import pickBy from 'lodash/pickBy';
import {DEF_ROL_NAME} from '@/constants/models/Role'
import {currParams, paramsObj, createURI} from '@/utils';
import {useProps} from '@/Shared/FuncComp'

export default ({filters, paramName="search", only=[], ...props}) => {
  const { filters: baseFilters, ...pageProps } = useProps();
  const [opened, setOpened] = useState(false);
  const params = currParams();
  
  if (!filters) filters = baseFilters;

  const [values, setValues] = useState(filters ? {
    role: filters.role || '', // role is used only on users page
    search: filters.search || (params.has(paramName)&&params.get(paramName)||'') || '',
    trashed: filters.trashed || ''
  } : {});

  const prevValues = usePrevious(values);
  
	useEffect(() => {
		const params = currParams();
		params.has(paramName) && !values.search && setValues((p)=>{
			const newVals = {...p};
			let change = false;
			if (!newVals.search && params.has(paramName)) {
				newVals.search=params.get(paramName);
				change = true;
			}
			return change ? newVals : p;
		});
	}, [])

  function reset() {
    setValues({
      role: '',
      search: '',
      trashed: ''
    });
  }

  useEffect(() => {
    // https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
    if (prevValues) {
		let params = paramsObj();
		//const params = currParams();
		//params.delete('role');
		//params.delete('search');
		//params.delete('trashed');
		//params.delete('page');
		//params.delete('remember');
		params.role = undefined;
		params[paramName] = undefined;
		params.trashed = undefined;
		params.page = undefined;
		params.remember = undefined;
		//params.search = undefined;
		if (Object.keys(pickBy(values)).length) {
			Object.keys(pickBy(values)).forEach(key=>{
				//params.set(key, values[key]);
				//if (key=="search" && paramName!="search") key=paramName;
				params[key=="search" ? paramName : key] = values[key];
			});
		} else {
			//params.set('remember', 'forget');
			if (props.forget) params.remember = 'forget';
		}
      /*const query = Object.keys(pickBy(values)).length
        ? pickBy(values)
        : { remember: 'forget' };*/
		//const query = params.toString();
		if (only!=0) only.push("flash");
		Inertia.reload({data: params, only, replace: true}/*route(route().current(), query)*/);
    }
  }, [values]);

  function handleChange(e) {
    const key = e.target.name;
    const value = e.target.value;

    setValues(values => ({
      ...values,
      [key]: value
    }));

    if (opened) setOpened(false);
  }

  return !filters ? null : (
    <div className="flex items-center w-full max-w-md mr-4">
      <div className="relative flex w-full bg-white shadow rounded">
        {(filters.hasOwnProperty('role') || filters.hasOwnProperty('trashed')) && <><div
          style={{ top: '100%' }}
          className={`absolute ${opened ? '' : 'hidden'}`}
        >
          <div
            onClick={() => setOpened(false)}
            className="bg-black opacity-25 fixed inset-0 z-20"
          ></div>
          <div className="relative w-64 mt-2 px-4 py-6 shadow-lg bg-white rounded z-30">
            {filters.hasOwnProperty('role') && (
              <SelectInput
                className="mb-4"
                label="Role"
                name="role"
                value={values.role}
                onChange={handleChange}
              >
                <option value=""></option>
                {/*<option value="user">User</option>
                <option value="owner">Owner</option>*/}
                <option value={0}>{DEF_ROL_NAME}</option>
                {(pageProps.roles||[]).map(rol=>(<option value={rol.id} key={'role-'+rol.id}>
                	{rol.name}
                </option>))}
              </SelectInput>
            )}
            <SelectInput
              label="Papelera"
              name="trashed"
              value={values.trashed}
              onChange={handleChange}
            >
              <option value=""></option>
              <option value="with">Incluir Eliminados</option>
              <option value="only">Solo eliminados</option>
            </SelectInput>
          </div>
        </div>
        <button
          onClick={() => setOpened(true)}
          className="px-4 md:px-6 rounded-l border-r hover:bg-gray-100 focus:outline-none focus:border-white focus:shadow-outline focus:z-10"
        >
          <div className="flex items-baseline">
            <span className="text-gray-700 hidden md:inline">Filtro</span>
            <svg
              className="w-2 h-2 fill-current text-gray-700 md:ml-2"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 961.243 599.998"
            >
              <path d="M239.998 239.999L0 0h961.243L721.246 240c-131.999 132-240.28 240-240.624 239.999-.345-.001-108.625-108.001-240.624-240z" />
            </svg>
          </div>
        </button></>}
        <input
          className="relative w-full px-6 py-3 rounded-r focus:shadow-outline"
          autoComplete="off"
          type="text"
          name="search"
          value={values.search||''}
          onChange={handleChange}
          placeholder="Buscar…"
        />
      </div>
      {!!Object.keys(pickBy(values)).length && <button
        onClick={reset}
        className="ml-3 text-sm text-gray-600 hover:text-gray-700 focus:text-indigo-700 focus:outline-none"
        type="button"
      >
        {props.resetCnt||"Restablecer"}
      </button>}
    </div>
  );
};
